import template from './coworking-name.jade';
import validation from '../../../services/validation';
import './typeahead-popup.tpl.jade';

export default angular.module('cian.addForm.coworkingName', []).directive('cianAfAddressCoworkingName', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'addFormLayoutService',
    'coworkingService',
    function (addFormLayoutService, coworkingService) {
      this.opened = false;

      this.validation = validation(this.form, 'coworkingName', {
        required: 'Выберите коворкинг из списка доступных.',
      });

      this.selectCoworking = suggestItem => {
        coworkingService.setCoworking(suggestItem);

        addFormLayoutService.setShortForm(true);
      };

      const filterSuggestionsBySearchQuery = (searchQuery, suggestions) => {
        const lowerCaseValue = searchQuery.toLowerCase();

        const filteredSuggestions = suggestions.filter(el => {
          const lowerCaseName = el.name.toLowerCase();

          return lowerCaseName.includes(lowerCaseValue);
        });

        return filteredSuggestions.length ? filteredSuggestions : suggestions;
      };

      this.getSuggestions = searchQuery => {
        const suggestions = coworkingService.getCoworkingSuggests();

        // если пользователь ничего не ввел, то показываем полный список suggestions
        if (!searchQuery) {
          return suggestions;
        }

        return filterSuggestionsBySearchQuery(searchQuery, suggestions);
      };

      this.onBlur = () => {
        this.opened = false;

        // если не засеттан коворкинг, то кидаем ошибку валидации
        if (!coworkingService.isCoworkingAttached()) {
          this.form.coworkingName.$setValidity('required', false);
        }
      };

      this.onFocus = () => {
        this.opened = true;

        if (coworkingService.isCoworkingAttached()) {
          this.ad.coworking.id = undefined;
        }
      };
    },
  ],
  controllerAs: 'coworkingName',
  template,
})).name;
